import React,{useEffect, useState} from "react";
import {withRouter} from "react-router-dom"
const CartSummary = (props)=>{
    const [itemCount,setItemCount] = useState(0)
    useEffect(()=>{
        let quantity = 0;
        props.products.map(pr=>{
            quantity+=pr.quantity
        })
        setItemCount(quantity)
    },[props.order])
    let order = props.order 
    return(

    <div className="card  mb-3">
        <div className="card-body">

            {/* <h5 className="mb-3">The total amount of</h5> */}

            <ul className="list-group list-group-flush">
                {/* <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0">
                    Temporary amount
                <span>$25.98</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                    Shipping
                <span>Gratis</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 mb-3">
                    <div>
                        <strong>The total amount of</strong>
                        <strong>
                            <p className="mb-0">(including VAT)</p>
                        </strong>
                    </div> 
                    <span><strong>$53.98</strong></span>
                </li> */}
                <li className="list-group-item  px-0">
                    <div style={{display:"inline-flex",alignItems:"baseline"}}>
                       <h6> <strong>{`Subtotal (${itemCount}) items :`}</strong></h6>&nbsp;&nbsp;
                       <span><strong>{`Rs ${order.productsPrice}`}</strong></span>
                    </div>
                </li>
                
            </ul>

            <button 
                type="button" 
                className="btn btn-custom btn-block waves-effect waves-light"
                onClick={()=>props.history.push("/checkout")}
            >Go to checkout</button>

        </div>
    </div>
    )
}

export default withRouter(CartSummary);